import { createSlice } from '@reduxjs/toolkit';
import {
  BUILDING_SETTINGS_PRIORITIES, BuildingSettingsPriority, Day, DAYS,
} from '../screens/LocationManagement/components/BuildingSettingsModal/data';
import { Building } from '../screens/LocationManagement/components/AddBuildingModal';

type State = {
  id: string
  name: string
  SlaHours: BuildingSettingsPriority[],
  WorkingHours: Day[],
  badgeCount: number,
}

const initialState: State = {
  id: null, name: null, SlaHours: BUILDING_SETTINGS_PRIORITIES, badgeCount: 0, WorkingHours: DAYS,
};

const buildingIdSlice = createSlice({
  name: 'selectedBuilding',
  initialState,
  reducers: {
    updateBuildingId(state: State, action: { payload: string }) {
      state.id = action.payload;
    },
    updateBuildingName(state: State, action: { payload: string }) {
      state.name = action.payload;
    },
    updateSlaHours(state: State, action: { payload: BuildingSettingsPriority[] }) {
      state.SlaHours = action.payload ?? BUILDING_SETTINGS_PRIORITIES;
    },
    updateWorkingHours(state: State, action: { payload: Day[] }) {
      state.WorkingHours = action.payload ?? DAYS;
    },
    updateBadgeCount(state: State, action: { payload: number }) {
      state.badgeCount = action.payload;
    },
    updateSelectedBuilding(state: State, action: { payload: Building }) {
      state.id = action.payload.LocationId;
      state.name = action.payload.Name;
      state.SlaHours = action.payload.SlaHours;
      state.WorkingHours = action.payload.WorkingHours;
    },
  },
});

export const {
  updateBuildingId, updateBuildingName, updateSlaHours, updateBadgeCount, updateWorkingHours,
  updateSelectedBuilding,
} = buildingIdSlice.actions;

export default buildingIdSlice.reducer;
